export default __webpack_public_path__ + "static/media/silouhette.9a271fd1.jpg";